'use strict';

import {Buildings, isMobile, settingsData} from "../../settings";
import {changeLangToCurrent, isDesktopMode} from "../language/langSwitcher";

export class Tooltip {
    static #element = document.createElement('div');
    static #target = null;
    static #targets = new Set();

    constructor() {
        Tooltip.#element.classList.add('tooltip', 'hidden');
        Tooltip.#element.innerHTML = 'Lorem Ipsum';

        document.body.appendChild(Tooltip.#element);
        document.body.addEventListener('mousemove', Tooltip.#mousemoveHandler);
    }

    static addTarget(value) {
        Tooltip.#targets.add(value);
    }

    static removeTarget(value) {
        Tooltip.#targets.delete(value);
    }

    static get targets() {
        return Tooltip.#targets;
    }

    static #mousemoveHandler(event) {
        Tooltip.#targets.forEach((element) => {
            Tooltip.#target = event.target.closest(element) || null;
            Tooltip.#addContentFor(element);
        });

        Tooltip.#updateCoords.apply(this, [event.clientX + 15, event.clientY - 15]);
        Tooltip.#visible(!!Tooltip.#target);
    }

    static set content(content) {
        Tooltip.#element.innerHTML = content;
    }

    static set target(target) {
        Tooltip.#target = target;
    }

    static #updateCoords(x, y) {
        Tooltip.#element.style.left = `${x}px`;
        Tooltip.#element.style.top = `${y}px`;
    }

    static #remove() {
        Tooltip.#element && Tooltip.#element.remove();
    }

    static #visible(value) {
        value ?
            Tooltip.#element.classList.remove('hidden') :
            Tooltip.#element.classList.add('hidden');
    }

    static #addContentFor(element) {
        switch (element) {
            case '.search__result-item':
                const buildingName = Tooltip.#target?.getAttribute('data-engineid').split('_')[0];
                config.buildings.find(building => {
                    if (building.buildingEngineId === buildingName) {
                        if (building.buildingLabel.split(' ').length < 2) {
                            Tooltip.#element.innerHTML = `<span data-dictionary="building" class="language-string">${changeLangToCurrent('building')} ${building.buildingLabel}</span>`;
                        } else {
                            Tooltip.#element.innerHTML = building.buildingLabel;
                        }
                    }
                });
                break;
            default:
                break;
        }
    }
}